import React, { useState, useEffect, Fragment } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { bindActionCreators } from "redux";
import { connect, useDispatch, useSelector } from "react-redux";
import * as settingActions from "../../actions/settingActions";
import * as menteesRequestAction from "../../actions/menteesRequestAction";
import * as baseActions from "../../actions/baseActions";
import { Button, Col, Dropdown } from "react-bootstrap";
import UserSidebar from "../../Component/UserSidebar";
import Details from "./details";
import Relationship from "./relationship";
import { getSubdomainPath, UCWords } from "../../utils/helpers";
import Slider from "react-slick";
import DToolkit from "./dtoolkit";
import Moment from "moment";
import FeedbackMentor from "./FeedbackMentor";
import MentoringSession from "../../Component/MentoringSession";
import ReportUser from "../Forum/reportUser";
import { Tooltip } from "@mui/material";
import config from "../../config";
import rainbow from '../../assets/images/rainbow.png'
import ScheduleMeetingModal from "../MentorDashboard1/scheduleMeetingModal";
import { imgPath } from "../../utils/imagePath";
import ReactPaginate from "react-paginate";
import queryString from "query-string";
import { getDatabase, ref, get, set } from "firebase/database";
import PopupModalWithOk from "../../utils/helpers/popupModalOk";
import { loadRegMyMentors } from "./Slice/myMentorsSlice";
import PropTypes from "prop-types";

function SidebarAddClass(e) {
  e.preventDefault();
  document.getElementById("OnscrollBody").classList.toggle("show_sidebar");
}


function formatText(text) {
  let safeText = "";
  if (text === null || text === undefined) {
    safeText = text;
  } else if (typeof text === "string") {
    safeText = text;
  } else if (Array.isArray(text)) {
    safeText = text.join(", ");
  } else {
    safeText = String(text);
  }

  return safeText.split(/\r?\n/).map((line, index) => (
    <React.Fragment key={`${line}-${index}`}>
      {line}
      <br />
    </React.Fragment>
  ));
}

const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
  <button
    ref={ref}
    onClick={(e) => {
      e.preventDefault();
      onClick(e);
    }}
    style={{ backgroundColor: "white", border: "none" }}
  >
    {children}
    <span className="threedots" />
  </button>
));

CustomToggle.displayName = "CustomToggle";

CustomToggle.propTypes = {
  children: PropTypes.node,
  onClick: PropTypes.func,
};

const Index = (props) => {

  const { actions, userInfo, setting } = props;
  const { menteeRequestData, pagination, steps_labels } = useSelector((state) => state?.myMentors);
  const dispatch = useDispatch();
  const history = useNavigate();
  const location = useLocation();
  const [room, setRoom] = useState({ roomname: "" });
  const [userData, setUserData] = useState({});
  const [endRelationship, setEndRelationship] = useState({});
  const [modalShow, setModalShow] = useState(false);
  const [relationModalShow, setRelationModalShow] = useState(false);
  const [toolkitModalShow, setToolkitModalShow] = useState(false);
  const [modelData, setModelData] = useState("");
  const [model, setModel] = useState(false);
  const [sessionModel, setSessionModel] = useState(false);
  const [userData2, setUserData2] = useState({});
  const [reportModalShow, setReportModalShow] = useState(false);
  const [viewPage, setViewPage] = useState(0);
  const [scheduleModal, setScheduleModal] = useState(false);
  const [scheduleUser, setScheduleUser] = useState({});
  const [popupMessage, setPopupMessage] = useState("");
  const [showPopup, setShowPopup] = useState(false);

  const subDomainPath = getSubdomainPath();

  const Mentors_details = {
    dots: true,
    arrows: false,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 767
      },
    ],
  };

  const writeReview = (e, mentee_id, mentor_id, review) => {
    e.preventDefault();
    setModalShow(true);
    setUserData({
      mentee_id: mentee_id,
      mentor_id: mentor_id,
      mentee_review: review,
    });
  };

  const endRelationshipModal = (e, mentee_id, mentor_id, review, actionid) => {
    e.preventDefault();
    setRelationModalShow(true);
    setEndRelationship({
      mentee_id: mentee_id,
      mentor_id: mentor_id,
      mentor_review: review,
      actionid: actionid,
    });
  };

  const siteName = setting?.name?.trim() || `My Mentors`;

  useEffect(() => {
    const title = `${siteName} - My Mentors`;
    document.title = title;
  }, [siteName]);

  const refreshMentors = () => {
    const params = new URLSearchParams(location.search);
    const queryStringParsed = queryString.parse(location.search);
    const request = {};
    if (params.get("sort")) {
      request.sort = queryStringParsed["sort"];
      request.direction = queryStringParsed["direction"];
    }
    if (params.get("page")) {
      request.page = queryStringParsed["page"];
    }
    if (params.get("keyword")) {
      request.keyword = queryStringParsed["keyword"];
    }
    dispatch(loadRegMyMentors({ request, userId: userInfo.id, roleId: userInfo.role_id }));
  };

  useEffect(() => {
    refreshMentors();
  }, [userInfo?.id, location.search]);

  const downloadResume = (e, url) => {
    e.preventDefault();
    window.open(url, "_blank");
  };

  useEffect(() => {
    if (room?.roomname) {
      history("/chat?roomKey=" + room.roomname);
    }
  }, [room?.roomname, history]);

  const handleclickChat = async (item) => {
    const roomUser =
      item.mentor_id > item.mentee_id
        ? `${item.mentor_id}_${item.mentee_id}`
        : `${item.mentee_id}_${item.mentor_id}`;

    const time = Moment.utc().valueOf();

    const safeValue = (value) => (value === undefined || value === null ? "" : value);
    const mentorImage =
      item?.reg_fields?.image ||
      item?.mentors_image ||
      item?.mentor_image ||
      "";
    const mentorName =
      item?.mentor_name ||
      item?.mentors_name ||
      `${item?.reg_fields?.first_name || ""} ${item?.reg_fields?.last_name || ""}`.trim();

    console.log("Initiating chat with roomUser:", roomUser, "at time:", time, "for item:", item);

    const message = {
      mentor_name: safeValue(mentorName),
      mentor_image: safeValue(mentorImage),
      mentor_id: safeValue(item?.mentor_id),
      mentee_name: safeValue(`${userInfo?.first_name || ""} ${userInfo?.last_name || ""}`.trim()),
      mentee_image: safeValue(userInfo?.image),
      mentee_id: safeValue(userInfo?.id),
      role_id: safeValue(userInfo?.role_id),
      device_type: "Web",
      message: "",
      key: safeValue(roomUser),
      status: 0,
      time: Moment(new Date()).format("DD/MM/YYYY HH:mm:ss"),
      epoch: -1 * time,
    };
    // Update local state
    setRoom((prev) => ({ ...prev, roomname: roomUser }));
    const db = getDatabase();
    const mentorDatabaseKey = `users/${item.mentor_id}/${roomUser}`;
    const menteeDatabaseKey = `users/${item.mentee_id}/${roomUser}`;

    console.log("Checking chat room existence for mentor key:", mentorDatabaseKey, "and mentee key:", menteeDatabaseKey);

    try {
      const mentorSnapshot = await get(ref(db, mentorDatabaseKey));
      console.log("Mentor snapshot exists:", mentorSnapshot.exists(), "for key:", mentorDatabaseKey);
      if (!mentorSnapshot.exists()) {
        console.log("Chat room created for mentor at key:", mentorDatabaseKey);
        await set(ref(db, mentorDatabaseKey), message);
      }
      const menteeSnapshot = await get(ref(db, menteeDatabaseKey));
      console.log("Mentee snapshot exists::::::::::::::::::::::::", menteeSnapshot.exists(), "for key:", menteeDatabaseKey);
      if (!menteeSnapshot.exists()) {
        await set(ref(db, menteeDatabaseKey), message);
      }
    } catch (error) {
      console.error("Error creating chat room:", error);
    }
  };

  const handlePageClick = (data) => {
    setViewPage(data.selected);
    let page = data.selected + 1;
    const params = new URLSearchParams(location.search);
    params.set("page", page);
    history({
      pathname: "/my-mentors",
      search: "?" + params,
    });
    window.scrollTo(0, 0);
  };

  const viewReportModal = (e, item) => {
    e.preventDefault();
    setReportModalShow(true);
    setUserData2({ item: item, from: "user" });
  };

  const handleSchedule = (e, item) => {
    e.preventDefault();
    setScheduleModal(true)
    setScheduleUser(item)
  }

  const getDisplayText = (item, field, fallback = "") => {
    return item?.reg_fields?.[field] || fallback || "";
  };

  const getDynamicFieldLabel = (field) => {

    if (!field) return "";

    // FIRST PRIORITY -> API labels
    if (steps_labels?.[field]) {
      return steps_labels[field];
    }

    // FALLBACK
    return field
      .replaceAll("_", " ")
      .split(" ")
      .map(
        (word) =>
          word.charAt(0).toUpperCase() +
          word.slice(1).toLowerCase()
      )
      .join(" ");
  };

  const getProfileImage = (item) => {
    return item?.reg_fields?.image || item?.mentors_image || imgPath + "mentor_women_two.png";
  };

  const getLinkedInUrl = (item) => {
    return item?.reg_fields?.linkedin || item?.mentors_linkedin || "";
  };

  const renderDynamicField = (item, field, label) => {
    let value = item?.reg_fields?.[field] ?? item?.[field];

    if (!value) return null;

    if (field === "domains") {
      const domains = String(value)
        .split("||")
        .map((item) => item.trim())
        .filter(Boolean);

      return (
        <>
          <h3 className="mb-1">{label}</h3>
          <div className="mentro_text">
            <ul>
              {domains.map((domain, index) => (
                <li key={index}>{domain}</li>
              ))}
            </ul>
          </div>
        </>
      );
    }
    if (field === "past_board_roles") {
      let pastBoardRoles = [];
      if (Array.isArray(value)) {
        pastBoardRoles = value;
      } else if (typeof value === "string") {
        if (value.includes("||")) {
          pastBoardRoles = value.split("||").map((item) => item.trim()).filter(Boolean);
        } else if (value.trim()) {
          pastBoardRoles = [value.trim()];
        }
      }

      if (pastBoardRoles.length === 0) return null;

      return (
        <>
          <h3 className="mb-1">{label == "Past Board Roles" ? "Current / Past Board Roles" : label}</h3>
          <div>
            <ul style={{ listStyleType: "disc", paddingLeft: "20px", marginBottom: "10px" }}>
              {pastBoardRoles.map((pastBoardRole, index) => {
                const text = typeof pastBoardRole === "object"
                  ? `${pastBoardRole.rep_company_name ? pastBoardRole.rep_company_name + " – " : ""}${pastBoardRole.rep_board_title || ""}`
                  : pastBoardRole;
                return (
                  <li key={index} style={{ listStyleType: "disc", marginBottom: "4px", fontSize: "14px" }}>
                    {text}
                  </li>
                );
              })}
            </ul>
          </div>
        </>
      );
    }

    if (field === "objective") {
      const objective = String(value)
        .split("||")
        .map((item) => item.trim())
        .filter(Boolean);

      return (
        <>
          <h3 className="mb-1">{label}</h3>
          <div className="mentro_text">
            <ul>
              {objective.map((objective, index) => (
                <li key={index}>{objective}</li>
              ))}
            </ul>
          </div>
        </>
      );
    }

    return (
      <>
        <h3 className="mb-1">{label == "Past Board Roles" ? "Current / Past Board Roles" : label}</h3>
        {field == "about" ? (
          <div>
            <p>{formatText(value)}</p>
          </div>
        ) : (
          <div className="mentro_text">
            <ul><li>{formatText(value)}</li></ul>
          </div>
        )
        }
      </>
    );
  };

  const getAdditionalDynamicFields = (item) => {
    const exclude = new Set([
      "image",
      "linkedin",
      "resume",
      "name",
      // "organization",
      // "position",
      // "domains",
      "lgbtq_discussion",
      "mf_certified_coach",
      "mf_mental_health",
      "first_name",
      "last_name",
      "full_name"
    ]);

    return Object.keys(item?.reg_fields || {}).filter((field) => {
      const value = item?.reg_fields?.[field];

      return (
        !exclude.has(field) &&
        value !== undefined &&
        value !== null &&
        value !== ""
      );
    });
  };

  const renderAdditionalDynamicFields = (item) => {
    return getAdditionalDynamicFields(item).map((field) =>
      renderDynamicField(item, field, getDynamicFieldLabel(field))
    );
  };

  const getFieldValueAndStatus = (item, field) => {
    return (
      item?.reg_fields?.[field] !== undefined &&
      item?.reg_fields?.[field] !== null &&
      item?.reg_fields?.[field] !== ""
    );
  };

  const callAFun = (field) => {
    setPopupMessage("You have already raised the termination request. Please wait for the admin to review");
    setShowPopup(true);
    return false
  };

  const notFoundData = menteeRequestData?.some((res) => res?.status == 4);

  const getDynamicBooleanValue = (item, field, fallbackField = "") => {
    const dynamicValue = item?.reg_fields?.[field];

    // Handle dynamic API values
    if (
      dynamicValue === 1 ||
      dynamicValue === "1" ||
      dynamicValue === true ||
      dynamicValue === "true" ||
      dynamicValue === "Yes"
    ) {
      return true;
    }

    // fallback to old API fields
    const fallbackValue = item?.[fallbackField];

    return (
      fallbackValue === 1 ||
      fallbackValue === "1" ||
      fallbackValue === true
    );
  };

  return (

    <div>
      <div className="dashboard_outer">
        <UserSidebar />
        <div className="dashboard_inner">
          <div className="d-block mb-3 mb-md-0 mb-md-none toggle_btn_outer">
            <Link to="" onClick={SidebarAddClass} className="toggle_btn d-lg-none">
              <i className="fas fa-bars"></i>
            </Link>
          </div>
          <h1 className="dash_heading">View My Mentor</h1>
          <div className="box_wrap shadow-sm bg-white mentor_box">
            <Slider {...Mentors_details}>
              {menteeRequestData.map((item, key) => (
                <Fragment key={item.id}>
                  {item.status === 4 &&
                    item.is_completed !== 1 &&
                    item.mentee_termination_status !== 2 && (
                      <div className="mentro_details mb-2 mb-md-4 d-flex  flex-wrap">
                        <div className="mentro_details_leftbar">
                          <div className="mentor_pic">
                            <img src={getProfileImage(item)} alt="find a career mentor online" />
                          </div>
                          {getFieldValueAndStatus(item, 'linkedin') && getLinkedInUrl(item) &&
                            <div className="profile_btn mt-3">
                              <a
                                href={getLinkedInUrl(item)}
                                className="link_btn btn btn_red m-0"
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                <img src={"/assets/images/linkedin.png"} className="me-2 bg-white" alt="career mentoring services" />{" "}
                                Linkedin Profile
                              </a>
                            </div>
                          }
                          <div className="extar_info_link">
                            <ul className="px-0 pt-2 mentor_log">
                              {subDomainPath !== 'siddev' && (
                                <li>
                                  {getFieldValueAndStatus(item, "mf_mental_health") &&
                                    getDynamicBooleanValue(
                                      item,
                                      "mf_mental_health",
                                      "mf_mental_health"
                                    ) && (
                                      <Tooltip
                                        size="4xl"
                                        title={
                                          <h5>{config?.mf_mental_health}</h5>
                                        }
                                        describeChild
                                        arrow
                                      >
                                        <img src={imgPath + "usermind.svg"} alt="" />
                                      </Tooltip>
                                    )}
                                </li>
                              )}
                              {subDomainPath !== 'siddev' && (
                                <li>
                                  {getFieldValueAndStatus(item, "mf_certified_coach") &&
                                    getDynamicBooleanValue(
                                      item,
                                      "mf_certified_coach",
                                      "mf_certified_coach"
                                    ) && (
                                      <Tooltip
                                        size="4xl"
                                        title={
                                          <h5>{config?.mf_certified_coach}</h5>
                                        }
                                        describeChild
                                        arrow
                                      >
                                        <img alt=""
                                          src={
                                            imgPath +
                                            "useraward.svg"
                                          }
                                        />
                                      </Tooltip>
                                    )}
                                </li>
                              )}
                              {subDomainPath !== 'siddev' && (
                                <li>
                                  {getFieldValueAndStatus(item, "lgbtq_discussion") &&
                                    getDynamicBooleanValue(
                                      item,
                                      "lgbtq_discussion",
                                      "mentor_lgbtq_discussion"
                                    ) && (
                                      <Tooltip
                                        size="4xl"
                                        title={<h5>{config?.LGBTQ_discussion}</h5>}
                                        describeChild
                                        arrow
                                      >
                                        <img alt="" src={rainbow} />
                                      </Tooltip>
                                    )}
                                </li>
                              )}
                            </ul>
                          </div>
                        </div>
                        <div className="mentro_details_sidebar">
                          <div className="row py-2 py-md-4">
                            <Col xl={4}>
                              <div className="d-flex ">
                                <div className="name_info">
                                  {(item?.reg_fields?.first_name ||
                                    item?.reg_fields?.last_name ||
                                    item?.mentor_name) && (
                                      <h4 className="mb-0">
                                        {`${item?.reg_fields?.first_name || ""} ${item?.reg_fields?.last_name || ""}`.trim() ||
                                          item?.mentor_name}
                                      </h4>
                                    )}

                                  {/* {getFieldValueAndStatus(item, 'organization') && <h5>
                                    <span className="d-block">
                                      {getDisplayText(item, 'organization', item.mentors_organization)}
                                    </span>
                                  </h5>
                                  }
                                  {getFieldValueAndStatus(item, 'position') && <h5>{getDisplayText(item, 'position', item.mentors_position)}</h5>}
                                  {getFieldValueAndStatus(item, 'domains') && (
                                    <h5>{UCWords(getDisplayText(item, 'domains', item.mentor_all_main_area)?.replaceAll("||", " "))}</h5>
                                  )} */}
                                </div>
                              </div>
                            </Col>
                            <Col xl={8} className="">
                              <div className="current-mentees profile_btn d-flex justify-content-end align-items-center ">

                                <button
                                  className="link_btn btn btn_red"
                                  onClick={() => {
                                    setSessionModel(true);
                                    setModelData(item);
                                  }}
                                >
                                  Mentoring Session
                                </button>

                                {item.mentor_review && (
                                  <button
                                    className="link_btn btn btn_red"
                                    onClick={() => {
                                      setModel(true);
                                      setModelData(item);
                                    }}
                                  >
                                    Feedback
                                  </button>
                                )}
                                <button
                                  className="link_btn btn btn_red"
                                  onClick={() => handleclickChat(item)}
                                >
                                  <img
                                    src="/assets/images/msg.png"
                                    alt="msg_icon"
                                    className="me-2 bg-white"
                                  />{" "}
                                  Send Message
                                </button>

                                <button
                                  className="link_btn btn btn_red"
                                  onClick={(e) => {
                                    writeReview(
                                      e,
                                      item.mentee_id,
                                      item.mentor_id,
                                      item.mentee_review
                                    );
                                  }}
                                >
                                  <img
                                    src="/assets/images/review_blue.png"
                                    alt="review_icon"
                                    className="me-2 bg-white"
                                  />
                                  {item.mentee_review === "" &&
                                    "Write A Review"}
                                  {item.mentee_review !== "" &&
                                    "Update Review"}
                                </button>

                                {(item.mentee_termination_status === 0 ||
                                  item.mentee_termination_status === "") && (
                                    <>
                                      <button
                                        className="link_btn btn btn_red"
                                        onClick={(e) => {
                                          endRelationshipModal(
                                            e,
                                            item.mentee_id,
                                            item.mentor_id,
                                            item.mentor_review,
                                            item.id
                                          );
                                        }}
                                      >
                                        <img
                                          src="/assets/images/review_blue.png"
                                          alt="review_icon"
                                          className="me-2 bg-white"
                                        />{" "}
                                        Terminate the Relationship
                                      </button>
                                      <button
                                        className="link_btn btn btn_red"
                                        onClick={(e) => {
                                          handleSchedule(e, item);
                                        }}
                                      >
                                        <img
                                          src="/assets/images/review_blue.png"
                                          alt="review_icon"
                                          className="me-2 bg-white"
                                        />{" "}
                                        Schedule Meeting
                                      </button>
                                    </>
                                  )}
                                {(item.mentee_termination_status === 1 ||
                                  item.mentee_termination_status === 2) && (
                                    <Button
                                      to=""
                                      className="link_btn btn btn_red disabledCursor"
                                      title={"You have already raised the termination request. Please wait for the admin to review"}
                                      onClick={callAFun}
                                    >
                                      <img
                                        src="/assets/images/review_blue.png"
                                        alt="review_icon"
                                        className="me-2 bg-white"
                                      />{" "}
                                      Terminate the Relationship
                                    </Button>
                                  )}
                                <Dropdown>
                                  <Dropdown.Toggle as={CustomToggle} />
                                  <Dropdown.Menu
                                    style={{ marginTop: "10px" }}
                                    size="sm"
                                    title=""
                                  >
                                    <Dropdown.Item
                                      onClick={(e) => {
                                        viewReportModal(e, item);
                                      }}
                                    >
                                      Report
                                    </Dropdown.Item>
                                  </Dropdown.Menu>
                                </Dropdown>
                              </div>
                            </Col>
                          </div>
                          <ul className="date_list py-2 py-md-4">
                             <div className="d-flex align-items-center gap-5">
                            <li className="d-flex align-items-center">
                              <div className="date_icon">
                                <img
                                  src="/assets/images/calender.png"
                                  alt="calender_image"
                                />
                              </div>
                              <div className="date_content ps-2">
                                <span className="d-block">
                                  Session start date
                                </span>
                                <span className="d-block date" style={{ padding: '0px' }}>
                                  {item.session_start_date}
                                </span>
                              </div>
                            </li>

                            <li className="d-flex align-items-center">
                              <div className="date_icon">
                                <img
                                  src="/assets/images/calender.png"
                                  alt="calendericon"
                                />
                              </div>
                              <div className="date_content ps-2">
                                <span className="d-block">
                                  Session end date
                                </span>
                                <span className="d-block date" style={{ padding: '0px' }}>
                                  {item.session_end_date}
                                </span>
                              </div>
                            </li>
                            </div>
                            {item?.reg_fields?.resume && (
                              <li className="d-sm-flex align-items-center">
                                <div className="date_icon">
                                  <img
                                    src="/assets/images/pdf.png"
                                    alt="download-icon"
                                  />
                                </div>

                                <div className="date_content ps-2">
                                  <Link
                                    to=""
                                    className="d-block date color_red"
                                    onClick={(e) =>
                                      downloadResume(e, item?.reg_fields?.resume)
                                    }
                                  >
                                    Download Resume
                                  </Link>
                                </div>
                              </li>
                            )}

                            {/* <li className="d-flex align-items-center">
                              &nbsp;
                            </li> */}
                          </ul>

                          {getFieldValueAndStatus('about') && <>
                            <h3 className="mb-1">About me</h3>
                            <div className="">
                              <p>
                                {formatText(getDisplayText(item, 'about', item.mentors_about))}
                              </p>
                            </div>
                          </>
                          }
                          {renderAdditionalDynamicFields(item)}

                          {/* {item?.restrictions_boundaries && <>
                            <h3 className="mb-1">Restrictions Boundaries</h3>
                            <div className="">
                              <p>
                                {formatText(item?.restrictions_boundaries)}
                              </p>
                            </div>
                          </>
                          }

                          {item?.communication_tools && <>
                            <h3 className="mb-1">Communication Tools Preference</h3>
                            <div className="">
                              <p>
                                {formatText(item?.communication_tools)}
                              </p>
                            </div>
                          </>
                          }

                          {item?.frequency_communication && <>
                            <h3 className="mb-1">Preferred Frequency Communication</h3>
                            <div className="">
                              <p>
                                {formatText(item?.frequency_communication)}
                              </p>
                            </div>
                          </>
                          }

                          {item?.any_particular_program && <>
                            <h3 className="mb-1">Any Particular Program</h3>
                            <div className="">
                              <p>
                                {item?.any_particular_program_data}
                              </p>
                            </div>
                          </>}

                          {item?.topics && <>
                            <h3 className="mb-1">Topics</h3>
                            <div className="">
                              <p>
                                {item?.topics}
                              </p>
                            </div>
                          </>} */}
                        </div>
                      </div>
                    )}

                  {item.status === 4 &&
                    item.is_completed !== 1 &&
                    item.mentee_termination_status === 2 && (
                      <div
                        className="mentro_details mb-2 mb-md-4 d-flex  flex-wrap"
                        key={item.id}
                      >
                        <div className="mentro_details_leftbar">
                          <div className="mentor_pic">
                            <img
                              src={getProfileImage(item)}
                              alt="career mentoring for women"
                            />
                          </div>
                          {getFieldValueAndStatus(item, 'linkedin') && getLinkedInUrl(item) &&
                            <div className="profile_btn mt-3">
                              <a
                                href={getLinkedInUrl(item)}
                                className="link_btn btn btn_red m-0"
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                <img
                                  src={"/assets/images/linkedin.png"}
                                  className="me-2 bg-white"
                                  alt="career mentoring for women"
                                />{" "}
                                Linkedin Profile
                              </a>
                            </div>
                          }
                          <div className="extar_info_link">
                            <ul className="px-0 pt-2 mentor_log">
                              <li>
                                {getFieldValueAndStatus(item, "mf_mental_health") &&
                                  getDynamicBooleanValue(
                                    item,
                                    "mf_mental_health",
                                    "mf_mental_health"
                                  ) && (
                                    <Tooltip
                                      size="4xl"
                                      title={
                                        <h5>{config?.mf_mental_health}</h5>
                                      }
                                      describeChild
                                      arrow
                                    >
                                      <img alt=""
                                        src={
                                          imgPath +
                                          "usermind.svg"
                                        }
                                      />
                                    </Tooltip>
                                  )}
                              </li>
                              <li>
                                {getFieldValueAndStatus(item, "mf_certified_coach") &&
                                  getDynamicBooleanValue(
                                    item,
                                    "mf_certified_coach",
                                    "mf_certified_coach"
                                  ) && (
                                    <Tooltip
                                      size="4xl"
                                      title={
                                        <h5>{config?.mf_certified_coach}</h5>
                                      }
                                      describeChild
                                      arrow
                                    >
                                      <img alt=""
                                        src={
                                          imgPath +
                                          "useraward.svg"
                                        }
                                      />
                                    </Tooltip>
                                  )}
                              </li>
                              <li>
                                {getFieldValueAndStatus(item, "lgbtq_discussion") &&
                                  getDynamicBooleanValue(
                                    item,
                                    "lgbtq_discussion",
                                    "mentor_lgbtq_discussion"
                                  ) && (
                                    <Tooltip
                                      size="4xl"
                                      title={
                                        <h5>{config?.LGBTQ_discussion}</h5>
                                      }
                                      describeChild
                                      arrow
                                    >
                                      <img alt=""
                                        src={rainbow}
                                      />
                                    </Tooltip>
                                  )}
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div className="mentro_details_sidebar">
                          <div className="row py-2 py-md-4">
                            <Col xl={4}>
                              <div className="d-flex ">
                                <div className="name_info">
                                  {(item?.reg_fields?.first_name ||
                                    item?.reg_fields?.last_name ||
                                    item?.mentor_name) && (
                                      <h4 className="mb-0">
                                        {`${item?.reg_fields?.first_name || ""} ${item?.reg_fields?.last_name || ""}`.trim() ||
                                          item?.mentor_name}
                                      </h4>
                                    )}

                                  {/* {getFieldValueAndStatus(item, 'organization') &&
                                    <h5>
                                      <span className="d-block">
                                        {getDisplayText(item, 'organization', item.mentors_organization)}
                                      </span>
                                    </h5>
                                  }
                                  {getFieldValueAndStatus(item, 'position') && <h5>{getDisplayText(item, 'position', item.mentors_position)}</h5>}
                                  {getFieldValueAndStatus(item, 'domains') && <h5>{UCWords(getDisplayText(item, 'domains', item.mentor_all_main_area)?.replaceAll("||", " "))}</h5>} */}
                                </div>
                              </div>
                            </Col>
                            <Col xl={8} className="">
                              <div className="current-mentees profile_btn d-flex justify-content-end align-items-center ">
                                <button
                                  className="link_btn btn btn_red"
                                  onClick={() => {
                                    setSessionModel(true);
                                    setModelData(item);
                                  }}
                                >
                                  Mentoring Session
                                </button>

                                {item.mentor_review && (
                                  <button
                                    className="link_btn btn btn_red"
                                    onClick={() => {
                                      setModel(true);
                                      setModelData(item);
                                    }}
                                  >
                                    Feedback
                                  </button>
                                )}
                                <button
                                  className="link_btn btn btn_red"
                                  onClick={(e) => {
                                    writeReview(
                                      e,
                                      item.mentee_id,
                                      item.mentor_id,
                                      item.mentee_review
                                    );
                                  }}
                                >
                                  <img
                                    src="/assets/images/review_blue.png"
                                    alt="diversity champions for women"
                                    className="me-2 bg-white"
                                  />
                                  {item.mentee_review === "" &&
                                    "Write A Review"}
                                  {item.mentee_review !== "" &&
                                    "Update Review"}
                                </button>
                                <Link
                                  to=""
                                  className="link_btn btn btn_red"
                                  onClick={(e) => e.preventDefault()}
                                >
                                  Completed
                                </Link>
                                <Dropdown>
                                  <Dropdown.Toggle as={CustomToggle} />
                                  <Dropdown.Menu
                                    style={{ marginTop: "10px" }}
                                    size="sm"
                                    title=""
                                  >
                                    <Dropdown.Item
                                      onClick={(e) => {
                                        viewReportModal(e, item);
                                      }}
                                    >
                                      Report
                                    </Dropdown.Item>
                                  </Dropdown.Menu>
                                </Dropdown>

                              </div>
                            </Col>
                          </div>
                          <ul className="date_list py-2 py-md-4">
                             <div className="d-flex align-items-center gap-5">
                            <li className="d-flex align-items-center">
                              <div className="date_icon">
                                <img
                                  src="/assets/images/calender.png"
                                  alt="female mentoring programs"
                                />
                              </div>
                              <div className="date_content ps-2">
                                <span className="d-block">
                                  Session start date
                                </span>
                                <span className="d-block date" style={{ padding: '0px' }}>
                                  {item.session_start_date}
                                </span>
                              </div>
                            </li>

                            <li className="d-flex align-items-center">
                              <div className="date_icon">
                                <img
                                  src="/assets/images/calender.png"
                                  alt="career consultants for women"
                                />
                              </div>
                              <div className="date_content ps-2">
                                <span className="d-block">
                                  Session end date
                                </span>
                                <span className="d-block date" style={{ padding: '0px' }}>
                                  {item.session_end_date}
                                </span>
                              </div>
                            </li>
                            </div>
                            {item?.reg_fields?.resume && (
                              <li className="d-sm-flex align-items-center">
                                <div className="date_icon">
                                  <img
                                    src="/assets/images/pdf.png"
                                    alt="download-icon"
                                  />
                                </div>

                                <div className="date_content ps-2">
                                  <Link
                                    to=""
                                    className="d-block date color_red"
                                    onClick={(e) =>
                                      downloadResume(e, item?.reg_fields?.resume)
                                    }
                                  >
                                    Download Resume
                                  </Link>
                                </div>
                              </li>
                            )}

                            {/* <li className="d-flex align-items-center">
                              &nbsp;
                            </li> */}
                          </ul>
                          {getFieldValueAndStatus('about') &&
                            <>
                              <h3 className="mb-1">About me</h3>
                              <div className="">
                                <p>{formatText(getDisplayText(item, 'about', item.mentors_about))}</p>
                              </div>
                            </>
                          }
                          {renderAdditionalDynamicFields(item)}
                          {item?.restrictions_boundaries && <>
                            <h3 className="mb-1">Restrictions Boundaries</h3>
                            <div className="">
                              <p>
                                {formatText(item?.restrictions_boundaries)}
                              </p>
                            </div>
                          </>
                          }
                          {item?.communication_tools && <>
                            <h3 className="mb-1">Communication Tools Preference</h3>
                            <div className="">
                              <p>
                                {formatText(item?.communication_tools)}
                              </p>
                            </div>
                          </>
                          }
                          {item?.frequency_communication && <>
                            <h3 className="mb-1">Preferred Frequency Communication</h3>
                            <div className="">
                              <p>
                                {formatText(item?.frequency_communication)}
                              </p>
                            </div>
                          </>
                          }
                          {item?.any_particular_program && <>
                            <h3 className="mb-1">Any Particular Program</h3>
                            <div className="">
                              <p>
                                {item?.any_particular_program_data}
                              </p>
                            </div>
                          </>}
                          {item?.topics && <>
                            <h3 className="mb-1">Topics</h3>
                            <div className="">
                              <p>
                                {item?.topics}
                              </p>
                            </div>
                          </>}
                        </div>
                      </div>
                    )}

                  {item.status === 4 && item.is_completed === 1 && (
                    <div
                      className="mentro_details mb-2 mb-md-4 d-flex  flex-wrap"
                      key={item.id}
                    >
                      <div className="mentro_details_leftbar">
                        <div className="mentor_pic">
                          <img
                            src={getProfileImage(item)}
                            alt="career consultants for women"
                          />
                        </div>
                        {getFieldValueAndStatus(item, 'linkedin') && getLinkedInUrl(item) && <div className="profile_btn mt-3 ">
                          <a
                            href={getLinkedInUrl(item)}
                            className="link_btn btn btn_red m-0"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <img
                              src={"/assets/images/linkedin.png"}
                              className="me-2 bg-white"
                              alt="LinkedIn"
                            />{" "}
                            Linkedin Profile
                          </a>
                        </div>
                        }
                        <div className="extar_info_link">
                          <ul className="px-0 pt-2 mentor_log">
                            <li>
                              {getFieldValueAndStatus(item, "mf_mental_health") &&
                                getDynamicBooleanValue(
                                  item,
                                  "mf_mental_health",
                                  "mf_mental_health"
                                ) && (
                                  <Tooltip
                                    size="4xl"
                                    title={<h5>{config?.mf_mental_health}</h5>}
                                    describeChild
                                    arrow
                                  >
                                    <img alt=""
                                      src={
                                        imgPath +
                                        "usermind.svg"
                                      }
                                    />
                                  </Tooltip>
                                )}
                            </li>
                            <li>
                              {getFieldValueAndStatus(item, "mf_certified_coach") &&
                                getDynamicBooleanValue(
                                  item,
                                  "mf_certified_coach",
                                  "mf_certified_coach"
                                ) && (
                                  <Tooltip
                                    size="4xl"
                                    title={<h5>{config?.mf_certified_coach}</h5>}
                                    describeChild
                                    arrow
                                  >
                                    <img src={imgPath + "useraward.svg"} alt=""
                                    />
                                  </Tooltip>
                                )}
                            </li>
                            <li>
                              {getFieldValueAndStatus(item, "lgbtq_discussion") &&
                                getDynamicBooleanValue(
                                  item,
                                  "lgbtq_discussion",
                                  "mentor_lgbtq_discussion"
                                ) && (
                                  <Tooltip
                                    size="4xl"
                                    title={
                                      <h5>{config?.LGBTQ_discussion}</h5>
                                    }
                                    describeChild
                                    arrow
                                  >
                                    <img src={rainbow} alt="" />
                                  </Tooltip>
                                )}
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="mentro_details_sidebar">
                        <div className="row py-2 py-md-4">
                          <Col xl={4}>
                            <div className="d-flex ">
                              <div className="name_info">

                                {(item?.reg_fields?.first_name ||
                                  item?.reg_fields?.last_name ||
                                  item?.mentor_name) && (
                                    <h4 className="mb-0">
                                      {`${item?.reg_fields?.first_name || ""} ${item?.reg_fields?.last_name || ""}`.trim() ||
                                        item?.mentor_name}
                                    </h4>
                                  )}

                                {/* {getFieldValueAndStatus(item, 'organization') && <h5>
                                  <span className="d-block">
                                    {getDisplayText(item, 'organization', item.mentors_organization)}
                                  </span>
                                </h5>
                                }
                                {getFieldValueAndStatus(item, 'position') && <h5>{getDisplayText(item, 'position', item.mentors_position)}</h5>}
                                {getFieldValueAndStatus(item, 'domains') && <h5>{UCWords(getDisplayText(item, 'domains', item.mentor_all_main_area)?.replaceAll("||", " "))}</h5>} */}
                              </div>
                            </div>
                          </Col>
                          <Col xl={8} className="">
                            <div className="current-mentees profile_btn d-flex justify-content-end align-items-center">

                              <button
                                className="link_btn btn btn_red"
                                onClick={() => {
                                  setSessionModel(true);
                                  setModelData(item);
                                }}
                              >
                                Mentoring Session
                              </button>

                              {item.mentor_review && (
                                <button
                                  className="link_btn btn btn_red"
                                  onClick={() => {
                                    setModel(true);
                                    setModelData(item);
                                  }}
                                >
                                  Feedback
                                </button>
                              )}
                              <button
                                className="link_btn btn btn_red"
                                onClick={() => handleclickChat(item)}
                              >
                                <img
                                  src="/assets/images/msg.png"
                                  alt="msg_icon"
                                  className="me-2 bg-white"
                                />{" "}
                                Send Message
                              </button>
                              <button
                                className="link_btn btn btn_red"
                                onClick={(e) => {
                                  writeReview(
                                    e,
                                    item.mentee_id,
                                    item.mentor_id,
                                    item.mentee_review
                                  );
                                }}
                              >
                                <img
                                  src="/assets/images/review_blue.png"
                                  alt="review_icon"
                                  className="me-2 bg-white"
                                />
                                {item.mentee_review === "" &&
                                  "Write A Review"}
                                {item.mentee_review !== "" && "Update Review"}
                              </button>
                              <Link
                                to=""
                                className="link_btn btn btn_red"
                                onClick={(e) => e.preventDefault()}
                              >
                                Completed
                              </Link>
                              <Dropdown>
                                <Dropdown.Toggle as={CustomToggle} />
                                <Dropdown.Menu
                                  style={{ marginTop: "10px" }}
                                  size="sm"
                                  title=""
                                >
                                  <Dropdown.Item
                                    onClick={(e) => {
                                      viewReportModal(e, item);
                                    }}
                                  >
                                    Report
                                  </Dropdown.Item>
                                </Dropdown.Menu>
                              </Dropdown>
                            </div>
                          </Col>
                        </div>
                        <ul className="date_list py-2 py-md-4">
                           <div className="d-flex align-items-center gap-5">
                          <li className="d-flex align-items-center">
                            <div className="date_icon">
                              <img
                                src="/assets/images/calender.png"
                                alt="calender_image"
                              />
                            </div>
                            <div className="date_content ps-2">
                              <span className="d-block">
                                Session start date
                              </span>
                              <span className="d-block date" style={{ padding: '0px' }}>
                                {item.session_start_date}
                              </span>
                            </div>
                          </li>

                          <li className="d-flex align-items-center">
                            <div className="date_icon">
                              <img
                                src="/assets/images/calender.png"
                                alt="calendericon"
                              />
                            </div>
                            <div className="date_content ps-2">
                              <span className="d-block">
                                Session end date
                              </span>
                              <span className="d-block date" style={{ padding: '0px' }}>
                                {item.session_end_date}
                              </span>
                            </div>
                          </li>
                          </div>
                          {item?.reg_fields?.resume && (
                            <li className="d-sm-flex align-items-center">
                              <div className="date_icon">
                                <img
                                  src="/assets/images/pdf.png"
                                  alt="download-icon"
                                />
                              </div>

                              <div className="date_content ps-2">
                                <Link
                                  to=""
                                  className="d-block date color_red"
                                  onClick={(e) =>
                                    downloadResume(e, item?.reg_fields?.resume)
                                  }
                                >
                                  Download Resume
                                </Link>
                              </div>
                            </li>
                          )}

                          {/* <li className="d-flex align-items-center">
                            &nbsp;
                          </li> */}
                        </ul>
                        {getFieldValueAndStatus('about') &&
                          <>
                            <h3 className="mb-1">About me</h3>
                            <div className="about-text">
                              <p>{formatText(getDisplayText(item, 'about', item.mentors_about))}</p>
                            </div>
                          </>}
                        {renderAdditionalDynamicFields(item)}
                        {item?.restrictions_boundaries && <>
                          <h3 className="mb-1">Restrictions Boundaries</h3>
                          <div className="">
                            <p>
                              {formatText(item?.restrictions_boundaries)}
                            </p>
                          </div>
                        </>
                        }
                        {item?.communication_tools && <>
                          <h3 className="mb-1">Communication Tools Preference</h3>
                          <div className="">
                            <p>
                              {formatText(item?.communication_tools)}
                            </p>
                          </div>
                        </>
                        }
                        {item?.frequency_communication && <>
                          <h3 className="mb-1">Preferred Frequency Communication</h3>
                          <div className="">
                            <p>
                              {formatText(item?.frequency_communication)}
                            </p>
                          </div>
                        </>
                        }
                        {item?.any_particular_program && <>
                          <h3 className="mb-1">Any Particular Program</h3>
                          <div className="">
                            <p>
                              {item?.any_particular_program_data}
                            </p>
                          </div>
                        </>}
                        {item?.topics && <>
                          <h3 className="mb-1">Topics</h3>
                          <div className="">
                            <p>
                              {item?.topics}
                            </p>
                          </div>
                        </>}

                        {(item?.mentor_board_entity_type) && <div className="mentro_text">
                          <h3 className="mb-1">Board Entity Type Experience</h3>
                          <ul>
                            {item.mentor_board_entity_type.map((entity) => (
                              <li key={entity.id}>{entity.title}</li>
                            ))}
                          </ul>
                        </div>}
                      </div>
                    </div>
                  )}
                </Fragment>
              ))}
            </Slider>
            {(menteeRequestData.length === 0 || pagination?.total == 0 || !notFoundData) && (
              <div className="text-center">No mentor found.</div>
            )}
            {pagination.total_pages && !(menteeRequestData.length === 0 || pagination?.total == 0 || !notFoundData) && (
              <ReactPaginate
                previousLabel={"<"}
                nextLabel={">"}
                siblingCount={5}
                forcePage={viewPage}
                breakLabel={"..."}
                breakClassName={"break-me"}
                pageCount={pagination.total_pages}
                marginPagesDisplayed={2}
                pageRangeDisplayed={2}
                onPageChange={(v) => handlePageClick(v)}
                containerClassName={"pagination"}
                subContainerClassName={"pages pagination"}
                activeClassName={"active"}
              />
            )}
          </div>
        </div>
      </div>
      {modalShow && (
        <Details
          show={modalShow}
          userdata={userData}
          onHide={() => setModalShow(false)}
          refreshList={refreshMentors}
          centered
          size="xl"
          className="mentor_modal"
        />
      )}
      {model && (
        <FeedbackMentor
          show={model}
          userdata={modelData}
          onHide={() => setModel(false)}
          centered
          size="xl"
          className="mentor_modal"
        />
      )}
      {sessionModel && (
        <MentoringSession
          show={sessionModel}
          userInfo={userInfo}
          userdata={modelData}
          actions={actions}
          onHide={() => setSessionModel(false)}
          centered
          size="xl"
          className="mentor_modal"
        />
      )}
      {reportModalShow && (
        <ReportUser
          show={reportModalShow}
          userdata={userData2}
          onHide={() => setReportModalShow(false)}
          centered
          size="xl"
          className="mentor_modal"
        />
      )}
      {toolkitModalShow && (
        <DToolkit
          show={toolkitModalShow}
          onHide={() => setToolkitModalShow(false)}
          centered
          size="xl"
          className="mentor_modal"
        />
      )}
      {relationModalShow && (
        <Relationship
          show={relationModalShow}
          endrelationship={endRelationship}
          refreshList={refreshMentors}
          actions={actions}
          onHide={() => setRelationModalShow(false)}
          centered
          size="xl"
          className="mentor_modal"
        />
      )}
      {scheduleModal && (
        <ScheduleMeetingModal
          show={scheduleModal}
          scheduleUser={scheduleUser}
          onHide={() => setScheduleModal(false)}
          setting={setting}
          centered
          size="xl"
          className="mentor_modal"
        />
      )}

      <PopupModalWithOk
        show={showPopup}
        onHide={() => {
          setShowPopup(false); // close popup
        }}
        message={popupMessage}
        showConfirm={false}
        staticBackdrop={true}
      />

    </div>
  );
};

Index.propTypes = {
  setting: PropTypes.shape({
    mentor_fields_json: PropTypes.string,
    name: PropTypes.string,
    organization: PropTypes.string,
    position: PropTypes.string,
  }).isRequired,
  userInfo: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    first_name: PropTypes.string,
    last_name: PropTypes.string,
    image: PropTypes.string,
    role_id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  }).isRequired,
  menteeRequestData: PropTypes.array.isRequired,
  pagination: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
  return {
    menteeRequestData: state.menteeRequestData,
    userInfo: state.userInfo,
    setting: state.setting,
    isAuth: state.isAuth,
    pagination: state.pagination
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      { ...menteesRequestAction, ...baseActions, ...settingActions },
      dispatch
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Index);
